$(document).ready(function () {
  $('.header__menu-item').on('click', function () {
    if ($(this).attr('aria-expanded') === 'true') {
      $('.section-header').addClass('white-header');
    } else {
      $('.section-header').removeClass('white-header');
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
    const megaMenu = document.getElementById("Details-HeaderMenu-1");
    if (megaMenu) {
        megaMenu.addEventListener("mouseenter", function () {
            megaMenu.setAttribute("open", "true"); // Open the mega menu on hover
        });
        megaMenu.addEventListener("mouseleave", function () {
            megaMenu.removeAttribute("open"); // Close the mega menu when the mouse leaves
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const megaMenus = document.querySelectorAll("details.mega-menu");
    megaMenus.forEach((menu) => {
        const summary = menu.querySelector("summary");
        const content = menu.querySelector(".mega-menu__content");
        // Open when hovering over the menu
        summary.addEventListener("mouseenter", function () {
            menu.setAttribute("open", "true");
        });
        content.addEventListener("mouseenter", function () {
            menu.setAttribute("open", "true"); // Keep open when inside content
        });
        // Close when mouse leaves BOTH the summary and content
        menu.addEventListener("mouseleave", function () {
            menu.removeAttribute("open");
        });
    });
});


document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".product__accordion details summary").forEach((summary) => {
        summary.addEventListener("click", function (event) {
            event.preventDefault(); // Prevent default toggle behavior

            let details = this.parentElement; // Get the parent <details> element

            // Close all other open accordions
            document.querySelectorAll(".product__accordion details[open]").forEach((openDetail) => {
                if (openDetail !== details) {
                    openDetail.removeAttribute("open");
                    openDetail.querySelector("summary").setAttribute("aria-expanded", "false");
                }
            });

            // Toggle the clicked accordion
            if (details.hasAttribute("open")) {
                details.removeAttribute("open");
                this.setAttribute("aria-expanded", "false");
            } else {
                details.setAttribute("open", "");
                this.setAttribute("aria-expanded", "true");
            }
        });
    });
});

